<template>
  <div class="c-equipmentArchive__colResults">
    <div class="c-equipmentArchive__results">
      <div class="c-equipmentArchive__results__tags">
        <ul>
          <li v-for="r_launched in recently_launched" v-bind:key="r_launched.term_id">
            <header-tag v-on="$listeners" :r_launched="r_launched"></header-tag>
          </li>
          <li v-for="line in lines" v-bind:key="line.term_id">
            <header-tag v-on="$listeners" :line="line"></header-tag>
          </li>
          <li v-for="body_part in body_parts" v-bind:key="body_part.post_id">
            <header-tag v-on="$listeners" :body_part="body_part"></header-tag>
          </li>
          <li v-for="type in types" v-bind:key="type.term_id">
            <header-tag v-on="$listeners" :type="type"></header-tag>
          </li>
        </ul>
      </div>
      <div v-if="count == 1" class="c-equipmentArchive__results__number">
        <span>{{ count }} {{ result_title }}</span>
      </div>
      <div v-if="count > 1" class="c-equipmentArchive__results__number">
        <span>{{ count }} {{ results_title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTag from "./HeaderTag";

export default {
  name: 'Header',
  props: {
    lines: [],
    body_parts: [],
    types : [],
    recently_launched: [],
    count: Number
  },
  data() {
    return {
      // translation
      result_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.result_title : '',
      results_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.results_title : '',
    }
  },
  components : {
    HeaderTag
  }
}
</script>
